import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input } from 'reactstrap';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../../order/Order.sass';
import { updateOrderDetailInfoAction } from '../../../actions/order';

class OrderSummary13Payment extends React.Component {
  static propTypes = {
    modelDataText: PropTypes.shape().isRequired,
    modelData: PropTypes.shape().isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
    orderDetailInfo: PropTypes.shape().isRequired,
  };

  onClickUpdatePaymentMethod(e) {
    console.warn(e);
    this.props.updateOrderDetailInfoAction('payment_method', null, e);
  }

  render() {
    return (
      <div className={`${s.summaryPPassenger}`}>
        <p className={s2.orderSmallTitle}>
          {this.props.modelDataText.order_summary_payment_title}
        </p>
        <hr className={s2.hrBottom} />
        <Row>
          {this.props.modelData.order_model_data.payment_method.map(p => [
            <Col md="12" xs="12" style={{ marginLeft: '15px' }} key="0">
              <Input
                type="radio"
                name={p.option_name}
                value={p.option_code}
                checked={
                  this.props.orderDetailInfo.payment_method === p.option_code
                }
                onChange={() => {
                  this.onClickUpdatePaymentMethod(p.option_code);
                }}
              />
              <span
                style={{ cursor: 'pointer' }}
                tabIndex={0}
                role="button"
                onClick={() => {
                  this.onClickUpdatePaymentMethod(p.option_code);
                }}
                onKeyPress={() => {}}
              >
                {p.title}
              </span>
              {typeof p.details !== 'undefined' ? (
                <span className={s2.summaryPaymentOptionDetails}>
                  {p.details}
                </span>
              ) : (
                ''
              )}
            </Col>,
            <br key="1" />,
          ])}
        </Row>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  remark: state.order.remark,
  passengerCount: state.order.passenger_count,
  tunnel: state.order.tunnel,
  images: state.order.images,
  vehicle: state.order.vehicle,
  pickupTime: state.order.pickup_time,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  orderDetailInfo: state.order.orderDetailInfo,
});
const mapDispatch = {
  updateOrderDetailInfoAction,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(OrderSummary13Payment),
);



// WEBPACK FOOTER //
// ./src/routes/OrderSummary/OrderSummary13Payment/OrderSummary13PaymentKR.js